import GET_CATEGORIES from "../plugins/getCategories"

const [w, d, l, content] = [window, document, location, 'topics']

const replace_item = () => {
  $('.contents .wrapLink', '.element_list').each((i, obj) => {
    let href = obj.getAttribute('href')
    let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
    let is_new = obj.querySelectorAll('span.new').length > 0 ? true : false
    let catObj = obj.querySelector('.catetitle a')
    let cat = catObj ? catObj.innerText : ''
    let dateObj = obj.querySelector('p.date')
    let date = dateObj ? dateObj.innerText : false
    let title = obj.querySelector('h5 > a').getAttribute('title')
    let desc = obj.querySelector('p.catch').innerText
    $(obj).replaceWith(`
    <a class="${content}-item" href="${href}">
      <figure class="${content}-item__img">
        <div class="${content}-item__img-cover" style="background-image:url( ${thumb} )">
          <img src="${thumb}" width="200">
        </div>
        ${(catObj)? `<span class="cate">${cat}</span>`: '' }
      </figure>
      <div class="${content}-item__body">
        <h4 class="subject">
          ${title}
          ${is_new ? '<span class="new">NEW</span>': ''}
        </h4>
        ${(desc)? `<span class="desc">${desc}</span>`: ''}
        ${(date)? `<small class="date">${date.replace(/\//g,'.')}</small>`: ''}
      </div>
    </a>
    `)
  })
}


const detail_init = async the_id => {

  // 全記事取得
  let articles = await $.getArticles({
    content
  })
  let categories = await $.getCategories({
    content
  })
  let the_article = articles.filter(a => (a.id == the_id)).shift()
  the_article.category = categories.filter(c => c.id == the_article.category)[0]

  let $head = $(`
    <div class="${content}-detail__head">
      ${the_article.category.name ? `<span class="cat hidden-xsmall">${the_article.category.name}</span>`: '' }
      <h3 class="title">${the_article.title}</h3>
      ${the_article.desc.length ? `<p class="desc">${the_article.desc}</p>`: '' }
      ${the_article.category.name ? `<span class="cat visible-xsmall">${the_article.category.name}</span>`: '' }
      <p class="date">${w.datetostr( the_article.date * 1000, 'YYYY.MM.DD' )}</p>
    </div>
  `)
  $('.element_detail > .title, .detail_title').remove();
  $head.prependTo('.element_detail');
  $('#main .detailfooter').appendTo('#container');

}

const list_init = () => {

  $('.element_list .list_title1').remove();
  replace_item();

  
  let $pagination = $('#main .element_list > .paginationbox').wrapAll('<div class="paginationbox__wrap" />');
  $pagination.parent().appendTo('#container');
}

const init = () => {

  // サイドカラムのサムネイル画像差し替え
  $('.artloop .thum_img img', '#side').each((i, obj) => {
    obj.src = obj.src.replace(/\/thumb-/, '/');
  })

  // カテゴリ一覧取得
  $(`.${content}-catelist`).insertAfter('.mainImg')
  GET_CATEGORIES(`.${content}-catelist[data-plugin="getCategories"]`);

}

export default function TOPICS() {
  $(() => {
    init()
    if (w.query_string('article')) detail_init(w.query_string('article'));
    if (!w.query_string('article') && d.body.classList.contains('is--list')) list_init();
  })
}